import {
  SIDE_NAV_LIGHT,
  NAV_TYPE_SIDE,
  DIR_LTR,
} from "constants/ThemeConstant";

export const APP_NAME = "Join Sanatan";
export const APP_ORG_NAME = "Akhand Sanatan Yuva Hindu Sangathan";
export var SERVER_TYPE = "Production";
//SERVER_TYPE = "Development";
export const APP_URL =
  SERVER_TYPE === "Development"
    ? "http://localhost:3000/"
    : "https://akhandsanatan.com/";

export const ANDROID_PACKAGE_ID = "com.joinsanatan";
export const ANDROID_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.joinsanatan";
export const IOS_STORE_URL =
  "https://apps.apple.com/in/app/joinsanatan/id1234567890";

export const APP_EMAIL = "";
export const LOGIN_BG_IMAGE = `${APP_URL}img/login-bg.jpg`; // public folder ke under img ke under add karo login-bg.jpg file
export const BANNER_LOGO_LG = `${APP_URL}img/logo-lg-resized.png`; // public folder ke under img ke under add karo logo-lg-resized.png file
export const PLACEHOLDER_BASE_URL_DEFAULT = `${APP_URL}img/`; // public folder ke under img ke under add karo userPlaceHolder.png file
export const PLACEHOLDER_BASE_URL_FILE = `${APP_URL}img/icons8-document-512.png`; // public folder ke under img ke under add karo icons8-document-512.png file
export const PLACEHOLDER_BASE_URL = `${APP_URL}img/userPlaceHolder.png`; // public folder ke under img ke under add karo userPlaceHolder.png file
export const ONERROR_BASE_URL = `${APP_URL}img/userPlaceHolder.png`; // public folder ke under img ke under add karo userPlaceHolder.png file
export const ONERROR_BASE_URL_HOLIDAY = `${APP_URL}img/login-bg.jpg`; // public folder ke under img ke under add karo login-bg.jpg file
export const PAGE_NOT_FOUN_IMAGE_URL = `${APP_URL}img/404.webp`; // public folder ke under img ke under add karo 404.webp file
export const APP_LOGO = `${APP_URL}img/logo.png`; // public folder ke under img ke under add karo logo.png file
export const APP_LOGO_SMALL = `${APP_URL}img/logo-sm.png`; // public folder ke under img ke under add karo logo-sm.png file
export const HEADER_APP_LOGO = `${APP_URL}img/logo-lg.png`; // public folder ke under img ke under add karo logo-lg.png file
export const HEADER_APP_LOGO_SMALL = `${APP_URL}img/logo-white.png`; // public folder ke under img ke under add karo logo-white.png file

//==================== App Config =================
export const APP_PREFIX_PATH = "";
export const AUTH_PREFIX_PATH = "";
export const REDIRECT_URL_KEY = "id";
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboard`;
export const UNAUTHENTICATED_ENTRY = ``;
export const REDIRECT = `/${APP_PREFIX_PATH}`;
export const AUTH_TOKEN = "auth_token";
export const NOTIAPPID = "f7df0708-8dd8-406f-813c-be6d1dc4618b";
export const BUFFERID = "f7df0708-8dd8-406f-813c-be6d1dc4618b";
export const MainThemeBackgroundColor =
  "linear-gradient(to bottom, #0a2a7a, #0d47a1)";

export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: "#377DFF",
  sideNavTheme2: SIDE_NAV_LIGHT, //testing
  locale: "hi",
  navType: NAV_TYPE_SIDE,
  topNavColor: "#377DFF",
  headerNavColor: "#fff",
  mobileNav: false,
  currentTheme: "light",
  direction: DIR_LTR,
  blankLayout: false,
  DivFormBackground: "#377DFF",
  ButtonBackground: "#ff9c00",

  ButtonCancelBackground: "#ff6b72",
  ThemeMainColor: "#377DFF",
};

//
//==================== api call url =================
export const API_ENDPOINT_URL =
  SERVER_TYPE === "Development"
    ? "https://pctude.com/api/"
    : "https://pctude.com/api/";
export const API_BASE_URL = `${API_ENDPOINT_URL}server`;
export const SERVER_LOGO_LG = `${API_BASE_URL}/logos/logo-lg.png`;
export const API_BASE_URL_FILE = `${API_ENDPOINT_URL}server/commen/upload`;
export const IMAGE_BASE_URL = API_BASE_URL;
export const PDF_BASE_URL = API_BASE_URL;
export const VIDEO_BASE_URL = API_BASE_URL;
export const CSV_BASE_URL = `${API_ENDPOINT_URL}server/`;

export const POLICY_TYPE = [];
export const ACCESS_PERMISSION_LEVEL = [];
export const ImageSvg = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
    <g>
      <g>
        <path
          fill="#E5E1E5"
          d="M163.033,1011.756L2.746,191.353c-4.863-24.879,11.365-48.991,36.245-53.852l124.042-24.234l194.642-42.82
			l279.663,941.308H163.033V1011.756z"
        />
      </g>
      <path
        fill="#99E6FC"
        d="M163.033,680.979L68.355,196.393l94.678-18.501l143.802-23.615l62.994,584.599L163.033,680.979z"
      />
      <g id="XMLID_159_">
        <g>
          <path
            fill="#F9F7F8"
            d="M1014.357,64.9v957.461c0,25.351-20.549,45.899-45.899,45.899H208.93
			  c-25.351,0-45.901-20.549-45.901-45.899V64.9c0-25.35,20.551-45.9,45.901-45.9h759.528C993.809,19,1014.357,39.551,1014.357,64.9
			  z"
          />
        </g>
        <path
          fill="#EFEDEF"
          d="M574.473,971.206c-90.848,0-164.495-73.646-164.495-164.493V19H208.93
			c-25.351,0-45.901,20.551-45.901,45.9v957.461c0,25.351,20.551,45.899,45.901,45.899h759.528
			c25.351,0,45.899-20.549,45.899-45.899v-51.155H574.473z"
        />
        <path
          fill="#FEC165"
          d="M950.933,737.554V234.861c0-7.122-5.774-12.896-12.897-12.896H239.354c-7.12,0-12.896,5.774-12.896,12.896
			v502.692H950.933z"
        />
        <path
          fill="#FDB441"
          d="M409.978,221.965H239.354c-7.12,0-12.896,5.774-12.896,12.896v502.692h183.52V221.965z"
        />
        <circle fill="#FEE903" cx="588.693" cy="600.309" r="246.948" />
        <path
          fill="#F4D902"
          d="M409.978,770.729V429.889c-42.274,44.316-68.229,104.339-68.229,170.419
			C341.748,666.391,367.703,726.41,409.978,770.729z"
        />
        <g>
          <path
            fill="#99E6FC"
            d="M902.813,668.316c-57.591-25.393-122.604-28.267-182.203-8.034l-51.163,17.336
			  c-52.369,17.759-109.135,17.759-161.505,0l-51.163-17.336c-59.602-20.232-124.611-17.358-182.182,8.034l-48.142,21.226v105.269
			  l80.12,33.354h599.658l44.699-33.354V689.542L902.813,668.316z"
          />
          <path
            fill="#62DBFB"
            d="M409.978,828.165V649.264c-45.72-6.239-92.605,0.184-135.379,19.053l-48.141,21.226v105.269
			  l80.119,33.354H409.978z"
          />
          <path
            fill="#62DBFB"
            d="M950.933,794.811v61.709c0,5.452-4.424,9.878-9.879,9.878H236.332c-5.453,0-9.877-4.426-9.877-9.878
			  v-61.709l48.142-21.229c57.57-25.39,122.58-28.268,182.182-8.055l51.163,17.358c52.37,17.759,109.136,17.759,161.505,0
			  l51.163-17.358c59.6-20.213,124.612-17.335,182.203,8.055L950.933,794.811z"
          />
          <path
            fill="#01D0FB"
            d="M236.332,866.397h184.86c-7.214-18.51-11.215-38.625-11.215-59.685v-52.188
			  c-45.72-6.231-92.605,0.192-135.379,19.061l-48.141,21.226v61.71c-0.003,5.451,4.421,9.875,9.874,9.875V866.397z"
          />
        </g>
      </g>
    </g>
  </svg>
);
